import { h, Component } from 'preact';
import style from './style';

import Back from '../../../components/back';

import { toast } from 'react-toastify';

import moment from 'moment';

var classNames = require('classnames/bind');
var cx = classNames.bind(style);

import { route } from 'preact-router';

import { apiGetRequest, apiPostRequest, apiDeleteRequest } from '../../../components/utils/api';
import Header from '../../../components/header';

export default class InviteMembers extends Component {
	constructor(props) {
        super(props);
        this.state = {
            period: "0",
            link: "",
            expiry: ""
        }
    }

    deleteLink() {
        this.props.changeAppLoading(true);
        apiDeleteRequest("teams/invite-link/?team=" + this.props.team.url_identifier, {}, true, this.props.authToken).then((data) => {
            console.log(data);
            if (data.ok) {
                this.setState({link: ""});
                this.props.changeAppLoading(false);
                this.props.mixpanel.track("Deleted Invite Link");
            }
        }).catch((error) => {
            console.log(error);
            this.props.changeAppLoading(false);
        })
    }

    postLink() {
        this.props.changeAppLoading(true);
        var postData = {
            period: this.state.period
        };
        apiPostRequest("teams/invite-link/?team=" + this.props.team.url_identifier, postData, true, this.props.authToken).then((data) => {
            console.log(data);
            if (data.token) {
                let link = window.location.origin + "/team/join/" + data.token;
                this.setState({link: link, expiry: data.expiry});
                this.props.changeAppLoading(false);
                this.props.mixpanel.track("Created New Invite Link");
            }
        }).catch((error) => {
            console.log(error);
            this.props.changeAppLoading(false);
        })
    }

    getLink() {
        this.props.changeAppLoading(true);
        apiGetRequest("teams/invite-link/?team=" + this.props.team.url_identifier, "", true, this.props.authToken).then((data) => {
            console.log(data);
            if (data.token) {
                let link = window.location.origin + "/team/join/" + data.token;
                this.setState({link: link, expiry: data.expiry});
                this.props.changeAppLoading(false)
            } else {
                this.props.changeAppLoading(false);
            }
        }).catch((error) => {
            console.log(error);
            this.props.changeAppLoading(false);
        })
    }

    componentDidMount() {
        this.getLink();
    }

    copy() {
        this.input.select();
        document.execCommand('copy');
        toast.success("🚀 Link copied!");
        this.props.mixpanel.track("Copied Invite Link");
    }


	render() {
        return (
            <div class={cx("home")}>
                <Header />

                <div class={cx("content")}>
                    <Back 
                        class={cx("back")}
                        cta={"Back to Members"}
                        callback={() => {
                            route("/team/management/members/")
                        }}
                    />

                    <div class={cx("heading")}>
                        <i class={cx("fa fa-paper-plane")} />
                        <h2>Invite Members to {this.props.team.team_name}</h2>
                    </div>

                    {this.state.link.length === 0 &&
                        <div class={cx("")}>
                            {/* <select placeholder={"Select An Option"} value={this.state.period} onChange={(e) => this.setState({period: e.target.value})}>
                                <option disabled>
                                    Select An Option
                                </option>
                                <option value={1}>
                                    Expires in 1 Day
                                </option>
                                <option value={7}>
                                    Expires in 7 Days
                                </option>
                                <option value={30}>
                                    Expires in 30 Days
                                </option>
                                <option value={0}>
                                    Never expires
                                </option>
                            </select> */}
                            <button type="button" onClick={() => this.postLink()}> 
                                Create Invite Link
                            </button>
                        </div>
                    }

                    {this.state.link.length > 1 && 
                        <div class={cx("link-container")}>
                            <p>Anyone can use this link to join {this.props.team.team_name} on Curatr.</p>
                            <div style={{display: "flex", width: "100%", justifyContent: "space-around"}}>
                                <input 
                                    ref={(elem) => this.input = elem}
                                    onClick={() => {
                                        this.copy();
                                    }}
                                    value={this.state.link}
                                    readonly
                                    
                                />
                                <button type="button" class={cx("button-base", "button-success", "button-copy")} onClick={() => this.copy()}>
                                    <p>Copy</p>
                                </button>
                            </div>
                            

                            {this.state.expiry == null &&
                                <p><small>This link never expires, need to change the link? <span onClick={() => this.deleteLink()} class={cx("delete-link")}>Click here</span></small></p>
                            }
                            {this.state.expiry !== null && 
                                <p><small>This link expires in {moment(this.state.expiry).fromNow(true)}, need to change this? <span onClick={() => this.deleteLink()} class={cx("delete-link")}>Click here</span></small></p>
                            }
                        </div>
                    }

                    
                </div>
            </div>
        );
	}
}




// WEBPACK FOOTER //
// ./routes/teams/inviteMembers/index.js